<template>
  <el-dialog
    :visible="visible"
    title="审核人设置"
    width="600px"
    :close-on-click-modal="false"
    :append-to-body="true"
    @close="handleClose"
  >
    <div class="reviewer-setting-content">
      <div
        v-for="reviewer in localReviewers"
        :key="reviewer.level"
        class="reviewer-row"
      >
        <el-checkbox v-model="reviewer.checked" />
        <span class="reviewer-label">
          {{ getLevelLabel(reviewer.level) }}级审核人：
        </span>
        <el-input
          v-model="reviewer.alias"
          placeholder="请输入别名"
          size="mini"
          class="alias-input"
        />
        <el-radio-group v-model="reviewer.targetType" size="mini">
          <el-radio label="any">任意人</el-radio>
          <el-radio label="designated">指定人</el-radio>
        </el-radio-group>
        <template v-if="reviewer.targetType === 'designated'">
          <el-button
            type="text"
            size="mini"
            style="color: #e6a23c"
            @click="openUserSelect(reviewer)"
          >
            选择
          </el-button>
          <span
            v-if="reviewer.designatedUsers && reviewer.designatedUsers.length > 0"
            class="selected-users"
          >
            （{{ reviewer.designatedUsers.map((u) => u.name).join(",") }}）
          </span>
        </template>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" type="primary" @click="handleSave">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getOauth2AccessToken } from "@/api/factory.js";

const TOKEN_KEY = "Oauth2-AccessToken";

export default {
  name: "ReviewerSettingDialog",
  props: {
    visible: Boolean,
    reviewers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localReviewers: [],
      currentSelectingReviewer: null,
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.initReviewers();
        }
      },
    },
  },
  methods: {
    getLevelLabel(level) {
      const labels = { 1: "一", 2: "二", 3: "三", 4: "四", 5: "五" };
      return labels[level] || level;
    },
    initReviewers() {
      if (this.reviewers && this.reviewers.length > 0) {
        this.localReviewers = JSON.parse(JSON.stringify(this.reviewers));
      } else {
        this.localReviewers = [1, 2, 3, 4, 5].map((level) => ({
          level,
          checked: false,
          alias: "",
          targetType: "any",
          designatedUsers: [],
        }));
      }
    },
    /**
     * 打开人员选择iframe
     */
    openUserSelect(reviewer) {
      this.currentSelectingReviewer = reviewer;
      const accessToken = getOauth2AccessToken();

      // 创建容器包裹 iframe 和关闭按钮
      const container = document.createElement("div");
      container.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
      `;

      const iframe = document.createElement("iframe");
      iframe.src = `${process.env.DESIGN_QUOTATION_PATH}/activity/userSelection?${TOKEN_KEY}=${accessToken}`;
      iframe.allow = "local-network-access";
      iframe.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
      `;

      // 关闭按钮
      const closeBtn = document.createElement("button");
      closeBtn.textContent = "✕";
      closeBtn.style.cssText = `
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 10000;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: none;
        background: rgba(0,0,0,0.5);
        color: #fff;
        font-size: 16px;
        cursor: pointer;
        line-height: 32px;
        text-align: center;
        padding: 0;
      `;
      closeBtn.onclick = () => {
        document.body.removeChild(container);
        window.removeEventListener("message", handleMessage);
        this.currentSelectingReviewer = null;
      };

      container.appendChild(iframe);
      container.appendChild(closeBtn);

      const handleMessage = (event) => {
        const { type, data } = event.data || {};
        if (type === "USER_SELECTION_READY") {
          iframe.contentWindow.postMessage(
            {
              type: "OPEN_USER_SELECTION",
              params: {
                selectedUser: (reviewer.designatedUsers || []).map((item) => ({
                  userId: item.approverId,
                  userName: item.name,
                })),
                orgSelectable: false,
              },
            },
            "*",
          );
        } else if (type === "USER_SELECTED") {
          if (data) {
            reviewer.designatedUsers = (data.selectedUser || []).map(
              (item) => ({
                // id: item.userId,
                approverId: item.userId,
                name: item.userName,
              }),
            );
          }
          document.body.removeChild(container);
          window.removeEventListener("message", handleMessage);
          this.currentSelectingReviewer = null;
        } else if (type === "USER_SELECTION_CANCEL") {
          document.body.removeChild(container);
          window.removeEventListener("message", handleMessage);
          this.currentSelectingReviewer = null;
        }
      };

      window.addEventListener("message", handleMessage);
      document.body.appendChild(container);
    },
    /**
     * 保存时校验
     */
    handleSave() {
      for (const reviewer of this.localReviewers) {
        if (!reviewer.checked) continue;
        // 勾选了则别名必填
        if (!reviewer.alias || !reviewer.alias.trim()) {
          this.$message.error(
            `第${this.getLevelLabel(reviewer.level)}级审核人已勾选，别名必填`,
          );
          return;
        }
        // 指定人则指定人必填
        if (
          reviewer.targetType === "designated" &&
          (!reviewer.designatedUsers || reviewer.designatedUsers.length === 0)
        ) {
          this.$message.error(
            `第${this.getLevelLabel(reviewer.level)}级审核人选择了指定人，请选择指定人`,
          );
          return;
        }
      }
      this.$emit("update:visible", false);
      this.$emit("confirm", JSON.parse(JSON.stringify(this.localReviewers)));
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.reviewer-setting-content {
  .reviewer-row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    gap: 8px;
    .reviewer-label {
      white-space: nowrap;
      min-width: 90px;
    }
    .alias-input {
      width: 120px;
    }
    .selected-users {
      color: #409eff;
      text-decoration: underline;
      font-size: 12px;
      margin-left: 4px;
    }
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
}
</style>



// WEBPACK FOOTER //
// ReviewerSettingDialog.vue?65ca0556